import { shape, string } from 'prop-types';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { Redirect } from 'react-router-dom';
import Grow from '@material-ui/core/Grow';
import { useTheme } from '@material-ui/core';
import Box from '@material-ui/core/Box';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import CardHeader from '@material-ui/core/CardHeader';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import { selectLoginIsInitialized } from '../Modules/auth/selectors';
import LoginForm from '../Modules/auth/components/LoginForm';
import { homePath } from '../Modules/nav/paths';
import LoadingPage from '../Modules/loading/components/LoadingPage';
import { useUser } from '../Modules/auth/hooks';

const useStyles = makeStyles({
    root: {
        maxWidth: 800,
        marginLeft: 'auto',
        marginRight: 'auto',
        width: '100%',
    },
});

const MaintenanceNotice = () => (
    <Card>
        <CardHeader title="Wartungsarbeiten" />
        <CardContent>
            <Typography>
                <h1>CRM-System vorübergehend offline</h1>
                <p>Liebe Kolleginnen und Kollegen, das CRM-System wird aktuell einer geplanten Wartung und Datenbank-Optimierung unterzogen. Während dieser Zeit stehen die Kundendaten kurzzeitig nicht zur Verfügung.</p>
                <div class="footer">
                    Vielen Dank für eure Geduld. Wir arbeiten daran, das System schnellstmöglich wieder bereitzustellen.
                </div>
            </Typography>
        </CardContent>
    </Card>
);

const useMaintenanceMode = () => {
    const [maintenanceMode, setMaintenanceMode] = useState(null);

    useEffect(() => {
        let cancelled = false;
        const configUrl = `${process.env.PUBLIC_URL}/maintenance.json?${Date.now()}`;

        fetch(configUrl, { cache: 'no-store' })
            .then((response) => {
                if (!response.ok) {
                    throw new Error('Maintenance configuration could not be loaded.');
                }

                return response.json();
            })
            .then(({ enabled }) => {
                if (!cancelled) {
                    setMaintenanceMode(enabled === true);
                }
            })
            .catch(() => {
                if (!cancelled) {
                    setMaintenanceMode(false);
                }
            });

        return () => {
            cancelled = true;
        };
    }, []);

    return maintenanceMode;
};

const LoginPage = ({ location: { state } }) => {
    const theme = useTheme();
    const classes = useStyles();
    const user = useUser();
    const isInitialized = useSelector(selectLoginIsInitialized);
    const maintenanceMode = useMaintenanceMode();

    if (user !== null) {
        const to = (state && state.from) || homePath;
        return <Redirect to={to} />;
    }

    return (
        <Grow in timeout={theme.transitions.duration.enteringScreen}>
            <LoadingPage loading={!isInitialized || maintenanceMode === null}>
                <Box mt={4} className={classes.root}>
                    {maintenanceMode ? <MaintenanceNotice /> : <LoginForm />}
                </Box>
            </LoadingPage>
        </Grow>
    );
};

LoginPage.propTypes = {
    location: shape({
        state: shape({
            from: shape({
                pathname: string.isRequired,
            }),
        }),
    }),
};

LoginPage.defaultProps = {
    location: { state: { from: { pathname: homePath } } },
};

export default LoginPage;
